export default {
	MARKET_TITLE: 'Market',
	TERRITORY_TITLE: 'Territory title',
};
